import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'Please provide a first name.' }
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'Please provide a last name.' }
      ]
    },
    clientname: {
      validations: []
    },
    addressline1: {
      validations: [
        { type: 'required', message: 'Please provide an address.' }
      ]
    },
    city: {
      validations: [
        { type: 'required', message: 'Please provide a city.' }
      ]
    },
    state: {
      validations: [
        { type: 'required', message: 'Please provide a state.' }
      ]
    },
    postal: {
      validations: [
        { type: 'required', message: 'Please provide a zip code.' }
      ]
    },
    telnumber: {
      validations: [
        { type: 'required', message: 'Please provide a phone number.' },
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number format that does not include spaces.' }
      ]
    },
    email: {
      validations: [
        { type: 'required', message: 'Please provide an email address.' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email.' }
      ]
    },
    category: {
      validations: [
        { type: 'required', message: 'Please provide an event type.' }
      ]
    },
    notes: {
      validations: []
    },
    accountextra3: {
      validations: []
    },
    accountextra5: {
      validations: []
    },
    accountextra6: {
      validations: [
        { type: 'required', message: 'Please provide a guest count.' }
      ]
    },
    accountextra7: {
      validations: [
        { type: 'required', message: 'Please provide a venue or location.' }
      ]
    },
    accountextra8: {
      validations: []
    },
    accountextra9: {
      validations: [
        { type: 'required', message: 'Please provide an event budget.' }
      ]
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name *',
            mapping: 'firstName'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name *',
            mapping: 'lastName'
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Company Name',
            mapping: 'clientname',
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Address *',
            mapping: 'addressline1',
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'City *',
            mapping: 'city',
          },
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'State *',
            options: [
              { label: 'AL', value: 'AL' },
              { label: 'AK', value: 'AK' },
              { label: 'AZ', value: 'AZ' },
              { label: 'AR', value: 'AR' },
              { label: 'CA', value: 'CA' },
              { label: 'CO', value: 'CO' },
              { label: 'CT', value: 'CT' },
              { label: 'DE', value: 'DE' },
              { label: 'DC', value: 'DC' },
              { label: 'FL', value: 'FL' },
              { label: 'GA', value: 'GA' },
              { label: 'HI', value: 'HI' },
              { label: 'ID', value: 'ID' },
              { label: 'IL', value: 'IL' },
              { label: 'IN', value: 'IN' },
              { label: 'IA', value: 'IA' },
              { label: 'KS', value: 'KS' },
              { label: 'KY', value: 'KY' },
              { label: 'LA', value: 'LA' },
              { label: 'ME', value: 'ME' },
              { label: 'MD', value: 'MD' },
              { label: 'MA', value: 'MA' },
              { label: 'MI', value: 'MI' },
              { label: 'MN', value: 'MN' },
              { label: 'MS', value: 'MS' },
              { label: 'MO', value: 'MO' },
              { label: 'MT', value: 'MT' },
              { label: 'NE', value: 'NE' },
              { label: 'NV', value: 'NV' },
              { label: 'NH', value: 'NH' },
              { label: 'NJ', value: 'NJ' },
              { label: 'NM', value: 'NM' },
              { label: 'NY', value: 'NY' },
              { label: 'NC', value: 'NC' },
              { label: 'ND', value: 'ND' },
              { label: 'OH', value: 'OH' },
              { label: 'OK', value: 'OK' },
              { label: 'OR', value: 'OR' },
              { label: 'PA', value: 'PA' },
              { label: 'RI', value: 'RI' },
              { label: 'SC', value: 'SC' },
              { label: 'SD', value: 'SD' },
              { label: 'TN', value: 'TN' },
              { label: 'TX', value: 'TX' },
              { label: 'UT', value: 'UT' },
              { label: 'VT', value: 'VT' },
              { label: 'VA', value: 'VA' },
              { label: 'WA', value: 'WA' },
              { label: 'WV', value: 'WV' },
              { label: 'WI', value: 'WI' },
              { label: 'WY', value: 'WY' }
            ],
            mapping: 'state',
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Postal *',
            mapping: 'postal',
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone Number *',
            mapping: 'telnumber',
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email Address *',
            mapping: 'email',
          },
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Event Type *',
            options: [
              { label: 'Wedding', value: 'Wedding'},
              { label: 'Social', value: 'Social'},
              { label: 'Corporate', value: 'Corporate'},
              { label: 'Other', value: 'Other'}
            ],
            mapping: 'category'
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Event Date',
            mapping: 'accountextra5',
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Guest Count *',
            mapping: 'accountextra6',
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Budget *',
            mapping: 'accountextra9',
          },
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Venue/Location *',
            options: [
              { label: 'Private Residence', value: 'Private Residence'},
              { label: 'Corporate Office', value: 'Corporate Office'},
              { label: '150 N. Riverside Plaza', value: '150 N. Riverside Plaza'},
              { label: '360 Chicago Elevated Events', value: '360 Chicago Elevated Events'},
              { label: 'Beverly Arts Center', value: 'Beverly Arts Center'},
              { label: 'Blumen Garden', value: 'Blumen Garden'},
              { label: 'Bridge 410', value: 'Bridge 410'},
              { label: 'Bridgeport Art Center - Sculpture Garden', value: 'Bridgeport Art Center - Sculpture Garden'},
              { label: 'Bridgeport Art Center - Skyline Loft', value: 'Bridgeport Art Center - Skyline Loft'},
              { label: 'Buffalo Creek Brewing', value: 'Buffalo Creek Brewing'},
              { label: 'Cantigny Park', value: 'Cantigny Park'},
              { label: 'Catalyst Ranch', value: 'Catalyst Ranch'},
              { label: 'Cheney Mansion', value: 'Cheney Mansion'},
              { label: 'Cosley Zoo', value: 'Cosley Zoo'},
              { label: 'Creativo Loft', value: 'Creativo Loft'},
              { label: 'Creek Bend Nature Center', value: 'Creek Bend Nature Center'},
              { label: 'Danada House', value: 'Danada House'},
              { label: 'Dupage County Historical Museum', value: 'Dupage County Historical Museum'},
              { label: 'Elmhurst Art Museum', value: 'Elmhurst Art Museum'},
              { label: 'Floating World Gallery', value: 'Floating World Gallery'},
              { label: 'Goodman Theatre', value: 'Goodman Theatre'},
              { label: 'Great Central Brewing', value: 'Great Central Brewing'},
              { label: 'Hoosier Grove Barn', value: 'Hoosier Grove Barn'},
              { label: 'Ida Noyes Hall', value: 'Ida Noyes Hall'},
              { label: 'Ignite Glass Studios', value: 'Ignite Glass Studios'},
              { label: 'International Museum of Surgical Science', value: 'International Museum of Surgical Science'},
              { label: 'Kenilworth Club', value: 'Kenilworth Club'},
              { label: 'Loft 21', value: 'Loft 21'},
              { label: 'Loft Lucia', value: 'Loft Lucia'},
              { label: 'Loft on Lake', value: 'Loft on Lake'},
              { label: 'Low Res Studio', value: 'Low Res Studio'},
              { label: 'Mary Lubko Center', value: 'Mary Lubko Center'},
              { label: 'Mayslake Peabody', value: 'Mayslake Peabody'},
              { label: 'McCormick Bridgehouse Museum', value: 'McCormick Bridgehouse Museum'},
              { label: 'Morgan\'s on Fulton', value: 'Morgan\'s on Fulton'},
              { label: 'Motor Row Brewery', value: 'Motor Row Brewery'},
              { label: 'Noah\'s Lincolnshire', value: 'Noah\'s Lincolnshire'},
              { label: 'Noah\'s Naperville', value: 'Noah\'s Naperville'},
              { label: 'Oak Park Conservatory', value: 'Oak Park Conservatory'},
              { label: 'On Tour Brewing', value: 'On Tour Brewing'},
              { label: 'Ovation', value: 'Ovation'},
              { label: 'Prairie Productions', value: 'Prairie Productions'},
              { label: 'Robert Morris University', value: 'Robert Morris University'},
              { label: 'Rockwell on The River', value: 'Rockwell on The River'},
              { label: 'Room 1520', value: 'Room 1520'},
              { label: 'Row 24', value: 'Row 24'},
              { label: 'Salvage One', value: 'Salvage One'},
              { label: 'St. Ignatius', value: 'St. Ignatius'},
              { label: 'Stan Mansion', value: 'Stan Mansion'},
              { label: 'Studio 6F', value: 'Studio 6F'},
              { label: 'The Brix', value: 'The Brix'},
              { label: 'The Grove at Redfield Estate', value: 'The Grove at Redfield Estate'},
              { label: 'The Lytle House', value: 'The Lytle House'},
              { label: 'The Haight', value: 'The Haight'},
              { label: 'The Tavern Club', value: 'The Tavern Club'},
              { label: 'Uptown Underground', value: 'Uptown Underground'},
              { label: 'Wandering Tree Estates', value: 'Wandering Tree Estates'},
              { label: 'Wendella Boat Tours', value: 'Wendella Boat Tours'},
              { label: 'Wheaton Community Center', value: 'Wheaton Community Center'},
              { label: 'Wilder Mansion', value: 'Wilder Mansion'},
              { label: 'Other', value: 'Other'}
            ],
            mapping: 'accountextra7',
          },
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'Medium',
            label: 'Message',
            mapping: 'notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'SUBMIT'
          }
        ]
      }
    ]
  },
  info: {
    title: 'True Cuisine Contact Form',
    formId: '309',
    clientKey: '7F32380D-81FF-4223-A218-5E337FCD6EB1',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: 'https://www.sbrevents.com/thank-you-page',
    submissionText: '',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;
